import {

    O365_LOAD_ROOMS_REQUEST,
    O365_LOAD_ROOMS_SUCCESS,

    CORE_LOAD_ROOMS_REQUEST,
    CORE_LOAD_ROOMS_SUCCESS,

    CORE_FIND_ROOM_REQUEST,
    CORE_FIND_ROOM_SUCCESS,

    CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST,
    CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS,

    CORE_SEARCH_ROOMS_REQUEST,
    CORE_SEARCH_ROOMS_SUCCESS,

    CORE_LOAD_VC_LIST_REQUEST,
    CORE_LOAD_VC_LIST_SUCCESS,

    O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST,
    O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS,

    CORE_GET_ALL_LOCATION_INFO_REQUEST,
    CORE_GET_ALL_LOCATION_INFO_SUCCESS,
} from '../../types'

const initialState = []
export default {
    roomsO365: (state = initialState, action) => {
        switch (action.type) {
            case O365_LOAD_ROOMS_REQUEST:
                return initialState
            case O365_LOAD_ROOMS_SUCCESS:
                return action.payload
            case O365_LOAD_ROOMS_BY_ADMIN_ID_REQUEST:
                return false
            case O365_LOAD_ROOMS_BY_ADMIN_ID_SUCCESS:
                if (action.payload && Array.isArray(action.payload))
                    return true
                else
                    return false
            default:
                return state
        }
    },
    roomsCore: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOMS_REQUEST:
            case CORE_SEARCH_ROOMS_REQUEST:
                return initialState
            case CORE_LOAD_ROOMS_SUCCESS:
            case CORE_SEARCH_ROOMS_SUCCESS:
                if (action.payload)
                    return action.payload
                else return []
            default:
                return state
        }
    },
    vcList: (state = [], action) => {
        switch (action.type) {
            case CORE_LOAD_VC_LIST_REQUEST:
                return []
            case CORE_LOAD_VC_LIST_SUCCESS:
                return action.payload
            default:
                return state
        }
    },
    roomCore: (state = initialState, action) => {
        switch (action.type) {
            case CORE_FIND_ROOM_REQUEST:
                return {}
            case CORE_FIND_ROOM_SUCCESS:
                if (action.payload)
                    return action.payload
                else return {}
            default:
                return state
        }
    },
    roomsSubscribe: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ROOMS_SUBSCRIBE_REQUEST:
                return initialState
            case CORE_LOAD_ROOMS_SUBSCRIBE_SUCCESS:
                if (action.payload)
                    return action.payload
                else return []
            default:
                return state
        }
    },
    allLocation: (state = initialState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_LOCATION_INFO_REQUEST:
                return initialState
            case CORE_GET_ALL_LOCATION_INFO_SUCCESS:
                if (action.payload)
                    return action.payload
                else return []
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/rooms/reducer.js